<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="hizmetTanimlama"> Hizmet Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="hizmetListesi"> Hizmet Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="hizmetDetay"> Hizmet Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="hizmetDurumGuncelle"> Hizmet Durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="hizmetGuncelle"> Hizmet Guncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import hizmetService from '../../../WSProvider/HizmetService';
    import notification from '../../../notification'
    import Hizmet from "./Hizmet";
    export default {
        name: "HizmetDetay",
        methods: {
            hizmetTanimlama() {
                hizmetService.hizmetTanimlama('HBT0001','PK-64000','link1234','baslik','altbaslik','icerik',["ygy","hgh"],'','','','url','2020-06-25','2020-06-27',1,1,'seobaslik','seoicerik');
            },
            hizmetDurumGuncelle() {
                hizmetService.hizmetDurumGuncelle('HBT0001','HK-1000',0);
            },
            hizmetListesi() {
                hizmetService.hizmetListesi('HBT0001',1);
            },
            hizmetDetay() {
                hizmetService.hizmetDetay('HK-1000');
            },
            hizmetGuncelle() {
                let updateList = [{
                    type: "link",
                    value: "llll5236"
                }];
                hizmetService.hizmetGuncelle('HBT0001','PJ-64008',updateList);
            }

        }
    }
</script>

<style scoped>

</style>